'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _lodash = require('lodash.clonedeep');

var _lodash2 = _interopRequireDefault(_lodash);

var _redux = require('redux');

var _utils = require('../utils');

var _register = require('../actions/register');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var INITIAL_STATE = {
    isFetching: false,
    error: {
        ok: true
    }
};

var registerReducer = function registerReducer() {
    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : INITIAL_STATE;
    var action = arguments[1];

    switch (action.type) {
        case _register.REQUEST_REGISTER:
            return _extends({}, state, {
                isFetching: true
            });
        case _register.RECEIVE_REGISTER:
            return _extends({}, state, {
                isFetching: false,
                lastUpdated: action.received_at,
                error: { ok: true }
            });
        case _register.FAILURE_REGISTER:
            return _extends({}, state, {
                isFetching: false,
                error: action.error
            });
        default:
            return state;
    }
};

exports.default = registerReducer;


//////////////////
// WEBPACK FOOTER
// ./src/js/reducers/register.js
// module id = 893
// module chunks = 0